import commonold from './module/common-old.js';
import emaki from './module/emaki.js';

(function ($) {
  //const ua = uajs();

  $(document).ready(function () {
    // アンカーリンク
    $('a').click(function (e) {
      let href = $(this).attr('href');
      if (href.match(/^#/) && $(href).length > 0) {
        e.preventDefault();
        $('html, body').animate({
          scrollTop: $(href).offset().top
        }, 'fast');
      }
    });

    // TOP colorbox

    $(window).on('load resize', function(){
      var spw = $(window).width();
      if (spw < 767){
        jQuery(function($){
          $(".youtube").colorbox({
            iframe:true,
            innerWidth:"90%",
            innerHeight: "30%",

            onComplete: function() {
              setTimeout(function(){
                  $.colorbox.position(0);
              },100);
            }
          });
        });
      }
      else if (spw > 768){
        $(".youtube").colorbox({
          iframe:true,
          innerWidth:960,
          innerHeight:585
        });
      }
    });

  });

})(jQuery);
